import Component from "@ember/component"
import { action, get } from "@ember/object"
import { oneWay } from "@ember/object/computed"
import { inject as service } from "@ember/service"
import { task } from "ember-concurrency"

export default class AdminSchoolYearIndex extends Component {
  @service("ember-store") store

  @service rpc

  @service session

  @service router

  @oneWay("fetchRecords.isRunning") isLoading

  columns = [
    {
      name: "ID",
      valuePath: "id",
    },
    {
      name: "Title",
      valuePath: "attributes.title",
    },
    {
      name: "Long Abbreviation",
      valuePath: "attributes.longAbbreviation",
    },
    {
      name: "Short Abbreviation",
      valuePath: "attributes.shortAbbreviation",
    },
    {
      name: "Years",
      valuePath: "attributes.years",
    },
  ]

  model = []
  enableSync = true

  didInsertElement() {
    this.fetchRecords.perform()
  }

  fetchRecords = task({ keepLatest: true }, async () => {
    let records = await this.rpc.execute("ADMIN_SCHOOL_YEAR_INDEX")
    // let records = await this.get('store').query('user', this.getProperties(['page', 'limit', 'sort', 'dir']));
    this.model.pushObjects(records.data)
  })

  @action
  onRowClick(row) {
    this.router.transitionTo("admin.school-years.show", get(row, "id"))
  }
}
